const INIT_DELAY_MS = 5000;
const FORM_OBSERVER_START_DELAY_MS = 12000;
const CLIENT_STORAGE_KEY = 'client';
const FORM_SUBMISSION_ENDPOINT = 'https://forms.shopifyapps.com/api/v2/form_submission';

let fetchObserverStarted = false;

function setClientAndReload() {
  try {
    window.localStorage?.setItem(CLIENT_STORAGE_KEY, 'true');
  } catch (error) {
    console.warn('Unable to set client flag in localStorage', error);
  }
  window.location.reload();
}

function initFormSubmissionFetchObserver() {
  if (fetchObserverStarted) return;
  fetchObserverStarted = true;

  const originalFetch = window.fetch?.bind(window);
  if (!originalFetch) {
    console.log('[toggle-list] window.fetch not available');
    return;
  }

  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init);

    try {
      const url = typeof input === 'string' ? input : input?.url;
      const method = init?.method || (typeof input === 'object' ? input?.method : undefined) || 'GET';
      console.log('[toggle-list] fetch', { url, method });
      if (url === FORM_SUBMISSION_ENDPOINT && method.toUpperCase() === 'POST') {
        console.log('[toggle-list] form submission detected via fetch');
        setClientAndReload();
      }
    } catch (error) {
      console.warn('Unable to inspect fetch for form submission', error);
    }

    return response;
  };
}

/**
 * @param {HTMLElement} toggleList
 */
function initToggleList(toggleList) {
  if (toggleList.dataset.toggleListInitialized === 'true') return;
  toggleList.dataset.toggleListInitialized = 'true';

  const isClient = window.localStorage?.getItem(CLIENT_STORAGE_KEY) === 'true';

  toggleList.querySelectorAll('[data-toggle-files]').forEach((files) => {
    if (files instanceof HTMLElement) {
      files.hidden = !isClient;
    }
  });

  toggleList.querySelectorAll('[data-toggle-signup]').forEach((signup) => {
    if (signup instanceof HTMLElement) {
      signup.hidden = isClient;
    }
  });

  toggleList.addEventListener('click', (event) => {
    if (event.target instanceof Element) {
      if (event.target.closest('summary') || event.target.closest('a')) return;
      const details = event.target.closest('details');
      if (!details) return;
      details.open = !details.open;
    }
  });

  setTimeout(() => {
    toggleList.querySelectorAll('[data-toggle-signup]').forEach((signup) => {
      signup.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const host = document.querySelector('shopify-forms-embed[id^="app-embed-container-"]');
        if (host?.shadowRoot) {
          const button = host.shadowRoot.querySelector('button, [role="button"]');
          if (button instanceof HTMLElement) button.click();
        }
      });
    });
  }, INIT_DELAY_MS);
}

function initAllToggleLists(root = document) {
  root.querySelectorAll('[data-toggle-list]').forEach((toggleList) => {
    if (toggleList instanceof HTMLElement) {
      console.log('[toggle-list] init toggle list', toggleList);
      initToggleList(toggleList);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAllToggleLists();
    setTimeout(initFormSubmissionFetchObserver, FORM_OBSERVER_START_DELAY_MS);
  });
} else {
  initAllToggleLists();
  setTimeout(initFormSubmissionFetchObserver, FORM_OBSERVER_START_DELAY_MS);
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) {
    initAllToggleLists(event.target);
  }
});
